import {React, useContext, useEffect, useRef, useState} from 'react';
import {toast, ToastContainer} from "react-toastify";
import GoBack from "../../components/goBack";
import {useNavigate} from "react-router-dom";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import {baseURL} from "../../services/api";
import Select from "react-select";
import {useTranslation} from "react-i18next";
import {trim} from "jquery";
import Swal from "sweetalert2";
import AuthContext from "../../components/shared/AuthContext";
import useAuthHelper from "../../helpers/AuthHelper";

const NewMember = () => {
    const navigate = useNavigate();
    const [t, i18n] = useTranslation();
    const {user} = useContext(AuthContext);
    const { maxTeamMembers } = useContext(AuthContext);

    const { onlyAdmins } = useAuthHelper();

    useEffect(() => {
        onlyAdmins();

        setWarning('');
        getTeamMembers();
        getOrgs();
    }, []);

    const getTeamMembers = async () => {
        try {
            const response = await jwtInterceoptor.get(`/data/team/list/${user.id}`);
            if (response.status === 200 && response.data && response.data.data) {
                setNumberOfTeamMembers(response.data.data.length);
            }
        } catch (error) {
            toast.error(t("Failed to load team members"));
        }
    };

    //states
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [permission, setPermission] = useState('');
    const [allOrgs, setAllOrgs] = useState([]);
    const [orgs, setOrgs] = useState([]);
    const [selectedOgs, setSelectedOgs] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [warning, setWarning] = useState('');
    const [passwordIdentique, setPasswordIdentique] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const permissionIsComptabilite = useRef();
    const permissionIsCommercial = useRef();
    const allPermission = useRef();
    const [hadAddAccess,setHadAddAccess] = useState(false);
    const [hadEditAccess,setHadEditAccess] = useState(false);
    const [hadDeleteAccess,setHadDeleteAccess] = useState(false);
    const [numberOfTeamMembers,setNumberOfTeamMembers]=useState(0);

    //get all users orgs
    const getOrgs = async () => {
        setLoaded(false);
        await jwtInterceoptor.get("/data/organisations")
            .then((response) => {
                if (response.data) {
                    let orgs = [];
                    let obj = {};

                    for (let i = 0; i < response.data.data.length; i++) {
                        obj = {
                            value: response.data.data[i]['id'],
                            label: response.data.data[i]['name']
                        };
                        orgs.push(obj);
                    }

                    setAllOrgs(orgs);
                    setLoaded(true);
                }
            })
            .catch((error) => console.log("error while retrieving all users's orgs : " + error))
    }

    const handleConfirmPassword = (confirmPassword) => {
        if (password === confirmPassword) {
            setWarning('');
            setPasswordIdentique(true);
        } else {
            setPasswordIdentique(false);
            setWarning('Mot de passe sont pas identique, Veuillez vérifier les mots de passe saisi !');
        }
    }

    const handleEyePasswordClick = (element) => {
        if (element === 'input1')
            var input = document.getElementById('pwd1');
        else
            var input = document.getElementById('pwd2');

        if (input.getAttribute('type') === 'password') {
            input.setAttribute('type', 'text');
        } else {
            input.setAttribute('type', 'password');
        }
    }

    const Save = async () => {
        /**
         *
         * @type {string}
         */
        let orgsString = '';

        if (password === '' || !passwordIdentique || name === '' || lastName === '' || email === '' || phone === '' || permission === '' || selectedOgs.length === 0) {
            toast.error(t('Tout les champs sont obligatoire'),
                {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                }
            );
        } else {
            /**
             *
             * @type {{object}}
             */
            let data={};

            orgsString = getIdsFromOrgsArray(selectedOgs);

            data = {
                name: name,
                lastName: lastName,
                email: email,
                phone: phone,
                password: password,
                permission: permission,
                orgs: orgsString,
                parent_id: user.id,
                had_add_access: hadAddAccess,
                had_edit_access: hadEditAccess,
                had_delete_access: hadDeleteAccess
            };
            console.log("data: ",data);

            const response = await jwtInterceoptor
                .post("/data/team/add", data)
                .then((res) => {
                    Swal.fire(
                        t("Nouveau membre d'équipe est créer avec succés"),
                        t(""),
                        "success"
                    );
                    navigate('/team/list');
                })
                .catch((error) => Swal.fire({
                    title: 'Error!',
                    text: 'cet email est déja utilisée',
                    icon: 'error',
                    confirmButtonText: 'OK'
                  }));
        }
    }

    const handleCheckboxChange = (value) => {
        setPermission(value);
    };

    const getIdsFromOrgsArray = (orgs) => {
        /**
         *
         * @type {string}
         */
        let string = '';

        for (let i = 0; i < orgs.length; i++) {
            if (i === 0)
                string += orgs[i]['value'];
            else
                string += ','+orgs[i]['value'];
        }
        return string;
    }

    const checkPack = (event) => {
        console.log("maxOrgs:", maxTeamMembers);
        console.log("numberOfTeamMembers:", numberOfTeamMembers);
        if (numberOfTeamMembers >= maxTeamMembers) {
            toast.warning(
                t("Vous avez atteint la limite de création de nouvelles membre d'équipe. Pour demander une modification de votre forfait, veuillez contacter le service commercial à l'adresse suivante : commerciale@elmanager.ma."),
                {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                }
            );
        } else {
            Save();
        }
    }

    return (
        <>
            <ToastContainer/>
            <div className="col-md-12" style={{display: loaded ? 'none' : 'block'}}>
                <center>
                    <div class="spinner-border text-primary me-2" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </center>
            </div>

            <div className="main-container container-fluid" style={{display: !loaded ? 'none' : 'block'}}><>
                <GoBack route={'/team/list'}/>

                <div className="page-header">
                    <h1 className="page-title breadcumpsHeader">Équipe de travail</h1>
                    <div>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="javascript:void(0)"
                                                               onClick={() => navigate('/team/list')}>Liste des membres
                                d'équipe</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">ajouter un membre</li>
                        </ol>
                    </div>
                </div>
            </>

                <div class="row">
                    <div class="col-xl-4">
                        <div class="card">
                            <div class="card-header">
                                <div class="card-title">Authentification</div>
                            </div>
                            <div class="card-body">
                                <div class="text-center chat-image mb-5">
                                    <div class="main-chat-msg-name">
                                        <a href="">
                                            <h5 class="mb-1 text-dark fw-semibold">{lastName.toUpperCase()} {name.toUpperCase()}</h5>
                                        </a>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label className="form-label">Mot de passe</label>
                                    <div class="wrap-input100 validate-input input-group" id="Password-toggle">
                                        <a onClick={() => handleEyePasswordClick('input1')} href="javascript:void(0)"
                                           className="input-group-text bg-white text-muted">
                                            <i class="zmdi zmdi-eye text-muted" aria-hidden="true"></i>
                                        </a>
                                        <input id="pwd1" className="input100 form-control" type="password"
                                               placeholder="test123"
                                               onChange={(e) => setPassword(e.target.value)}
                                               value={password}
                                        />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label className="form-label">Confirmer le mot de passe</label>
                                    <div class="wrap-input100 validate-input input-group" id="Password-toggle1">
                                        <a onClick={() => handleEyePasswordClick('input2')} href="javascript:void(0)"
                                           className="input-group-text bg-white text-muted">
                                            <i class="zmdi zmdi-eye text-muted" aria-hidden="true"></i>
                                        </a>
                                        <input id="pwd2" className="input100 form-control" type="password"
                                               placeholder="test123"
                                               onChange={(e) => handleConfirmPassword(e.target.value)}
                                        />
                                    </div>
                                    <p style={{color: 'red', fontWeight: 'bolder'}}> {warning} </p>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div class="col-xl-8">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Information générale</h3>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-lg-6 col-md-12">
                                        <div class="form-group">
                                            <label htmlFor="exampleInputname">Prénom</label>
                                            <input type="text" className="form-control" id="exampleInputname"
                                                   placeholder="prénom"
                                                   onChange={(e) => setName(e.target.value)}
                                                   value={name}
                                            />
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-12">
                                        <div class="form-group">
                                            <label htmlFor="exampleInputname1">Nom</label>
                                            <input type="text" className="form-control" id="exampleInputname1"
                                                   placeholder="Nom"
                                                   onChange={(e) => setLastName(e.target.value)}
                                                   value={lastName}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label htmlFor="exampleInputEmail1">Email</label>
                                    <input type="email" className="form-control" id="exampleInputEmail1"
                                           placeholder="Email"
                                           onChange={(e) => setEmail(e.target.value)}
                                           value={email}
                                    />
                                </div>
                                <div class="form-group">
                                    <label htmlFor="exampleInputnumber">Numéro de téléphone</label>
                                    <input type="number" className="form-control" id="exampleInputnumber"
                                           placeholder="+212 689956325"
                                           onChange={(e) => setPhone(e.target.value)}
                                           value={phone}
                                    />
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-lg-6">
                                <div class="card">
                                    <div class="card-header">
                                        <div class="card-title">Les permissions</div>
                                    </div>
                                    <div class="card-body">

                                        <div class="form-group mg-b-10">
                                            <label className="custom-switch ps-0">
                                                <input type="checkbox" name="custom-switch-checkbox"
                                                       className="custom-switch-input"
                                                       checked={permission === 'comptable'}
                                                       onChange={() => handleCheckboxChange('comptable')}
                                                       />
                                                <span class="custom-switch-indicator me-3"/>
                                                <span class="custom-switch-description mg-l-10">Comptabilité</span>
                                            </label>
                                        </div>



                                        <div class="form-group mg-b-10">
                                            <label className="custom-switch ps-0">
                                                <input type="checkbox" name="custom-switch-checkbox"
                                                       className="custom-switch-input"
                                                       checked={permission === 'commercial'}
                                                       onChange={() => handleCheckboxChange('commercial')}
                                                       />
                                                <span class="custom-switch-indicator me-3"></span>
                                                <span
                                                    class="custom-switch-description mg-l-10">Gestion commerciale</span>
                                            </label>
                                        </div>
                                        {permission === 'commercial' && (
                                            <div class="form-group">
                                                <label>Options de gestion commerciale :</label>
                                                <br />
                                                <div className="custom-switch ps-0">
                                                    <label className="custom-switch ps-0">
                                                        <input type="checkbox"
                                                        className="custom-switch-input"
                                                               checked={hadAddAccess}
                                                               onChange={(e) => setHadAddAccess(e.target.checked)}
                                                        />
                                                        <span class="custom-switch-indicator me-3"/>
                                                        <span class="custom-switch-description mg-l-10">Ajouter</span>
                                                    </label>
                                                </div>
                                                <br />
                                                <div className="custom-switch ps-0">
                                                    <label className="custom-switch ps-0">
                                                        <input type="checkbox"
                                                        className="custom-switch-input"
                                                               checked={hadEditAccess}
                                                               onChange={(e) => setHadEditAccess(e.target.checked)}
                                                        />
                                                        <span class="custom-switch-indicator me-3"/>
                                                        <span class="custom-switch-description mg-l-10">Modifier</span>
                                                    </label>
                                                </div>
                                                <br />
                                                <div className="custom-switch ps-0">
                                                    <label className="custom-switch ps-0">
                                                        <input type="checkbox"
                                                        className="custom-switch-input"
                                                               checked={hadDeleteAccess}
                                                               onChange={(e) => setHadDeleteAccess(e.target.checked)}
                                                        />
                                                        <span class="custom-switch-indicator me-3"/>
                                                        <span class="custom-switch-description mg-l-10">Supprimer</span>
                                                    </label>
                                                </div>
                                            </div>
                                        )}
                                        <div class="form-group mg-b-10">
                                            <label className="custom-switch ps-0">
                                                <input type="checkbox" name="custom-switch-checkbox"
                                                       className="custom-switch-input"
                                                       checked={permission === 'all'}
                                                       onChange={() => handleCheckboxChange('all')}
                                                       />
                                                <span class="custom-switch-indicator me-3"></span>
                                                <span
                                                    class="custom-switch-description mg-l-10">Les deux</span>
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="card">
                                    <div class="card-header">
                                        <div class="card-title">Les organisations</div>
                                    </div>
                                    <div class="card-body">

                                        <div class="form-group mg-b-10">
                                            <Select
                                                isMulti
                                                name="colors"
                                                options={allOrgs}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                onChange={(choices) =>
                                                    setSelectedOgs(choices)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="card">
                    <div className="card-footer">
                        <div className="row">

                            <div className="col-md-12">
                                <button disabled={isSubmit} type="button" className="btn btn-primary"
                                        onClick={checkPack}>{isSubmit ? t("Loading ...") : t("Enregistrer")}</button>
                                <a
                                    onClick={() => {
                                        navigate(-1);
                                    }}
                                    className="btn btn-default float-end">Annuler</a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}

export default NewMember;